import React from "react";

import { Box, Stack, Typography } from "@mui/material";

interface Props {
  name?: string;
  role?: string;
  company?: string;
  location?: string;
  bio?: string;
  coverImage?: string;
}

export const SuggestedMemberOverview: React.FC<Props> = ({
  name = "Lynda Smith",
  role = "Executive Business Advisory",
  company = "Overwatch Capital",
  location = "New York",
  bio = `Lynda Smith brings decades of strategic leadership to Overwatch Capital, where she serves as Executive
Business Advisory. Known for her ability to connect vision with execution, Lynda has built a career at the
intersection of aerospace innovation, transformative technology, and social impact.

Raised with a fascination for flight and exploration, she began her career in aerospace engineering, working
with leading space agencies and private companies during the formative years of commercial space travel. Her
early work helped shape partnerships between governments and the private sector, paving the way for
breakthroughs in satellite technology and orbital infrastructure. This foundation gave her a unique lens on how
bold innovation can be scaled into sustainable industries.`,
  coverImage = "https://www.figma.com/api/mcp/asset/e64ab4db-1340-4d15-96dd-3c9121196b86"
}) => {
  return (
    <Stack
      sx={{
        bgcolor: "white",
        borderRadius: "8px",
        p: "16px",
        gap: "10px",
        boxShadow: "0px 1px 2px 0px rgba(18, 18, 23, 0.1)"
      }}
    >
      <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#071f35", lineHeight: "24px" }}>
        Meet a new member
      </Typography>
      <Box
        component="img"
        src={coverImage}
        sx={{
          width: "100%",
          height: "217px",
          objectFit: "cover",
          borderRadius: "8px"
        }}
      />
      <Box
        sx={{
          borderBottom: "1px solid #dbe8f5",
          pb: "10px"
        }}
      >
        <Typography sx={{ fontSize: "24px", fontWeight: 700, color: "#071f35", lineHeight: "32px" }}>{name}</Typography>
        <Typography sx={{ fontSize: "16px", fontWeight: 400, color: "#071f35", lineHeight: "24px" }}>{role}</Typography>
        <Typography sx={{ fontSize: "16px", fontWeight: 400, color: "#496682", lineHeight: "24px" }}>
          {company}
        </Typography>
        <Typography sx={{ fontSize: "16px", fontWeight: 400, color: "#496682", lineHeight: "24px" }}>
          {location}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 400,
          color: "#071f35",
          lineHeight: "24px",
          whiteSpace: "pre-line"
        }}
      >
        {bio}
      </Typography>
      <Stack direction="row" justifyContent="flex-end">
        <Typography
          component="a"
          href="#"
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            color: "#26a6ae",
            textDecoration: "none",
            cursor: "pointer"
          }}
        >
          View profile
        </Typography>
      </Stack>
    </Stack>
  );
};
